import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { UserSearch, MapPin, Repeat } from 'lucide-react';
const pillars = [{
  icon: <UserSearch className="w-7 h-7" data-id="element-205" />,
  title: 'Identify & Engage Anonymous Visitors',
  desc: 'Turn unknown drivers at the pump into known, opted-in players you can market to.'
}, {
  icon: <MapPin className="w-7 h-7" data-id="element-206" />,
  title: 'Drive Local Traffic',
  desc: 'Pull nearby patrons off the forecourt and through your doors.'
}, {
  icon: <Repeat className="w-7 h-7" data-id="element-207" />,
  title: 'Turn One-Time Customers Into Repeat Visitors',
  desc: 'Recurring drawings give every fill-up a reason to come back.'
}];
export function SlideValue() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.18,
        delayChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 30
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 22
      }
    }
  };
  return <div className="w-full min-h-full flex flex-col justify-center p-[clamp(2rem,6vw,6rem)]" data-id="element-208">
      <div className="max-w-6xl mx-auto w-full" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-[clamp(2rem,4vw,3.5rem)]" data-id="element-210">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-surface border border-surface-hover text-accent text-sm font-bold tracking-wide uppercase mb-5" data-id="element-211">
            What It Delivers
          </div>
          <h2 className="text-[clamp(2.5rem,5vw,4.5rem)] font-bold leading-tight" data-id="element-212">
            Three Ways It{' '}
            <span className="text-accent text-glow" data-id="element-213">Grows Revenue</span>
          </h2>
        </motion.div>

        <motion.div variants={container} initial="hidden" animate="show" className="flex md:grid md:grid-cols-3 gap-4 md:gap-6 overflow-x-auto snap-x snap-mandatory hide-scrollbar pb-2 md:pb-0" data-id="element-214">
          {pillars.map((p, i) => <motion.div key={p.title} variants={item} className="min-w-[100%] md:min-w-0 snap-center p-6 md:p-8 rounded-3xl bg-surface border border-surface-hover flex flex-col" data-id="element-215">
              <div className="flex items-center gap-4 mb-4 md:mb-6" data-id="element-216">
                <div className="w-12 h-12 md:w-14 md:h-14 shrink-0 rounded-2xl bg-background flex items-center justify-center text-accent" data-id="element-217">
                  {p.icon}
                </div>
                <span className="text-4xl md:text-5xl font-black text-[rgba(59,246,93,0.35)] tracking-tighter leading-none" data-id="element-218">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>
              <h3 className="text-lg md:text-xl font-bold leading-snug mb-2 md:mb-3" data-id="element-219">
                {p.title}
              </h3>
              <p className="text-sm md:text-base text-muted leading-relaxed" data-id="element-220">
                {p.desc}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </div>;
}